import { render } from "./be00a980-b39f-11ee-8770-c85acf022408.vue?vue&type=template&id=71715ac4"
import script from "./be00a980-b39f-11ee-8770-c85acf022408.vue?vue&type=script&lang=js"
export * from "./be00a980-b39f-11ee-8770-c85acf022408.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__